<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{$t('MenuCategory.SelectMenu')}}</h2>
      <p class="title-lv4 mb20">{{menuCategory}}</p>
      <ul class="fk-menu-cat-select">
        <li v-if="model.visibleCoupon">
          <a href="#" @click.prevent="execCoupon()">
            <span class="text">{{model.couponButton.title}}</span>
            <span class="icon"><img :src="model.couponButton.imageUrl" :alt="model.couponButton.title"></span>
          </a>
        </li>
        <li v-for="(item, index) in itemList" :key="index">
          <a href="#" @click.prevent="executeSelect($event, index)">
            <span class="text">{{item.category_name}}</span>
            <span class="icon"><img v-bind:src="item.image_url" :alt="item.category_name"></span>
          </a>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  mixins: [ CommonMixin, DisplayErrorMixin ],
  name: 'FKMOCategoryList',
  data () {
    return {
      serverTime: null,
      itemList: [],
      menuCategory: null,
      requestFlag: {
        category: true,
        coupon: true
      },
      model: {
        couponButton: {
          title: null,
          imageUrl: null
        },
        visibleCoupon: false
      }
    }
  },
  computed: {
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getIsAcceptingMenu () {
      return this.$store.getters.isAcceptingMenu
    },
    getReceiveMethod () {
      return Number(this.$store.getters.cart.receive_method)
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    }
  },
  watch: {
    // 2つのrequestFlagを監視して、両方倒れた時点でボタン非活性フラグを倒す
    'requestFlag.category' (flg) {
      if (!flg && !this.requestFlag.coupon) {
        this.setDisabledButton(false)
      }
    },
    'requestFlag.coupon' (flg) {
      if (!flg && !this.requestFlag.category) {
        this.setDisabledButton(false)
      }
    }
  },
  methods: {
    executeSelect: function (event, index) {
      if (this.getDisabledButton) {
        return false
      }

      // 選択したカテゴリを記憶する
      this.$store.dispatch('setSelectCategory', this.itemList[index])

      // メニュー一覧に遷移する
      this.$router.push({ name: 'MenuList' })
    },
    execCoupon: function () {
      this.$router.push({ name: 'Coupon', params: { couponDetails: this.model.couponDetails } })
    },
    dispMenuCategory: function () {
      if (this.getIsAcceptingMenu.morning) {
        this.menuCategory = this.$i18n.t('ReceiveMethod.Morning')
      } else if (this.getIsAcceptingMenu.grand) {
        this.menuCategory = this.$i18n.t('ReceiveMethod.Grand')
      }
    },
    requestCouponApi: function () {
      const _that = this
      this.callApi('Coupon',
        {
          'store_cd': this.getSelectStore.store_cd,
          language: sessionStorage.getItem('lang')
        }
      )
      // this.axios.get('/static/stub/Coupon/coupon.json')
        .then((res) => {
          if (res.data.result) {
            if (res.data.value.coupon_details.length > 0) {
              _that.$store.dispatch('setCouponDetails', res.data.value.coupon_details)
            }
            _that.model.couponButton.title = res.data.value.coupon_category_name || null
            _that.model.couponButton.imageUrl = res.data.value.coupon_category_image_url || null
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.requestFlag.coupon = false
          _that.model.visibleCoupon = true // クーポンボタンはリクエストが完了したら表示する
        })
    },
    requestCategoryApi: function () {
      let _that = this

      // typeフラグを決定する
      let type = null
      if (this.getIsAcceptingMenu.morning) {
        type = 1
      } else if (this.getIsAcceptingMenu.grand) {
        type = 2
      }
      // カテゴリー一覧を取得する
      let params = {
        'store_cd': this.getSelectStore.store_cd,
        type,
        'receive_method': this.getReceiveMethod,
        language: sessionStorage.getItem('lang')
      }
      this.callApi('GetCategoryItem',
        params
      )
      // this.axios.get('/static/stub/getCategoryItem.json')
        .then(function (res) {
          if (res.data.result) {
            _that.itemList = res.data.value.category_list

            // 画像をバインディングする
            for (let i = 0; i < _that.itemList.length; i++) {
              _that.itemList[i].image_url = _that.importImageUri(_that.itemList[i].image_url)
            }
          } else {
            _that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          _that.errorFromAxios(error)
        })
        .finally(() => {
          _that.requestFlag.category = false
        })
    },
    resetSelectItem: function () {
      // 選択したアイテムの個数をリセットする
      const selectItem = this.$store.getters.selectItem
      selectItem.quantity = 1
      this.$store.dispatch('setSelectItem', selectItem)
    },
    init: function () {
      this.setDisabledButton(true)
      this.resetSelectItem()
      this.requestCategoryApi()
      this.requestCouponApi()
      // NOTE APIを2本キックするため、ボタン非活性フラグの倒し方を以下のようにする。
      // ・コンポーネントにリクエスト中フラグを立てる。通信が終わったら対応するフラグを倒す。
      // ・リクエスト中フラグをwatchし、両方が倒れたタイミングでボタン非活性フラグを倒す。
    }
  },
  beforeMount () {
    // サーバー時間
    this.serverTime = this.getServerTime

    this.init()

    this.dispMenuCategory()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MenuCategory.vue